"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_dom_1 = tslib_1.__importDefault(require("react-dom"));
var react_router_dom_1 = require("react-router-dom");
var mobx_react_1 = require("mobx-react");
var es6_promise_1 = tslib_1.__importDefault(require("es6-promise"));
var store_1 = require("../store");
var App_1 = require("./components/App");
var utils_1 = require("./utils");
require("../../node_modules/normalize-css/normalize.css");
require("../../node_modules/slick-carousel/slick/slick.css");
require("../../node_modules/react-image-lightbox/style.css");
require("./styles/_index.styl");
var initialState = utils_1.getInitialState();
var store = new store_1.Store(initialState);
function main() {
    es6_promise_1.default.polyfill();
    utils_1.initSentry();
    var App = function () { return (react_1.default.createElement(mobx_react_1.Provider, { store: store },
        react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
            react_1.default.createElement(App_1.App, null)))); };
    react_dom_1.default.hydrate(react_1.default.createElement(App, null), document.querySelector('#root'));
}
main();
